/*
 Created by qing on 2020/12/29
 Des:
 */

export const CONFIG_TYPE__DEFAULT = ''                   // 默认值
export const CONFIG_TYPE__TODO = 'TODO'                  // 我的待办
export const CONFIG_TYPE__QUICK_ENTRY = 'QUICK_ENTRY'    // 快捷入口
export const CONFIG_TYPE__APPS = 'APPS'                  // 常用应用
export const CONFIG_TYPE__CONTACT_ME = 'CONTACT_ME'      // 联系我们
export const CONFIG_TYPE__DASHBOARD = 'DASHBOARD'         // 仪表盘图表

export const TODO_SHOW_TYPE__WIDE = 'WIDE'      // 宽版待办
export const TODO_SHOW_TYPE__NARROW = 'NARROW'  // 窄版待办

export const CONFIG_STATUS_TYPE__EDIT = 0   // 处于编辑状态
export const CONFIG_STATUS_TYPE__VIEW = 1   // 处于展示状态
